import { CREATE_MESSAGE } from '../types';

const createMessage = msg => ({ type: CREATE_MESSAGE, payload: msg });
export default createMessage;
